import { render, staticRenderFns } from "./AddDayInterval.vue?vue&type=template&id=5590e0b6&"
import script from "./AddDayInterval.vue?vue&type=script&lang=ts&"
export * from "./AddDayInterval.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports